import { memo } from 'react';
import { ContentType } from '@amzn/awscat-pattern-library-service-model';

import GuideEditor from './GuideEditor';
import PatternEditor from './PatternEditor';
import { useContent } from '../v2-hooks/useContent';

/** The "Contents" tab body in the content editor. Dispatches to the editor for the loaded content type. */
const ContentsTabView = memo(function ContentsTabView() {
  const content = useContent();

  switch (content?.contentMetadata.contentType) {
    case ContentType.Guide:
    case ContentType.Strategy:
      // Users can no longer create Strategy content type,
      // However, we still support editing it.
      // It has the same format has Guide, so use the Guide editor:
      return <GuideEditor />;
    case ContentType.Pattern:
      return <PatternEditor />;
    default:
      // Intentionally throw so the nearest error boundary crashes the page
      // and reports to RUM. Unsupported (or missing) content types should
      // be loud, not silently rendered as empty.
      throw new Error(`Content type "${content?.contentMetadata.contentType}" is not supported.`);
  }
});

export default ContentsTabView;
